import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, MessageCircle, Sparkles } from 'lucide-react';
import { Button } from './ui/Button';
const inicioFeatures = ['Más de 200 páginas', '8 módulos completos', '5 BONUS incluidos', 'Recursos editables', 'Acceso inmediato'];
const premiumFeatures = ['Inicio en la Psicopedagogía Clínica', 'KIT PROFESIONAL PPI', 'Actividades para la práctica psicopedagógica', 'Planillas útiles para Psicope', 'Frases profesionales', 'Agenda Psico', 'Megapack Inclusión Educativa (Premium · $19.990)', 'Psicope en Casa (Premium · $19.990)'];
export function PricingSection() {
  return <section id="oferta" className="py-14 bg-gradient-to-b from-white to-pink-50/40 scroll-mt-8" data-id="element-145">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-146">
        <div className="text-center mb-8" data-id="element-147">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-navy-900 uppercase tracking-tight mb-3" data-id="element-148">
            Elegí cómo querés acceder
          </h2>
          <p className="text-lg text-slate-600" data-id="element-149">
            Accedé ahora al sistema completo para empezar clínica con más
            claridad.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto items-start pt-6" data-id="element-150">
          {/* Plan 1 — Inicio */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white rounded-3xl shadow-lg border border-slate-200 overflow-hidden flex flex-col" data-id="element-151">
            <div className="bg-slate-100 text-slate-700 text-center py-3 font-bold text-xs tracking-widest uppercase" data-id="element-152">
              🌸 Plan Inicio
            </div>
            <div className="p-8 flex flex-col flex-grow" data-id="element-153">
              <h3 className="font-serif text-xl font-bold text-navy-900 mb-1 uppercase tracking-tight" data-id="element-154">
                Inicio en la Psicopedagogía Clínica
              </h3>
              <p className="text-slate-600 text-sm mb-6" data-id="element-155">
                Ebook principal + 5 BONUS
              </p>

              <ul className="space-y-3 mb-8 flex-grow" data-id="element-156">
                {inicioFeatures.map((f, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-157">
                    <CheckCircle2 className="w-5 h-5 text-green-500 shrink-0 mt-0.5" data-id="element-158" />
                    <span className="text-slate-700 font-medium" data-id="element-159">{f}</span>
                  </li>)}
              </ul>

              <div className="mb-6 text-center" data-id="element-160">
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-161">
                  <span className="text-xs font-bold text-slate-500" data-id="element-162">ARS</span>
                  <span className="text-4xl font-bold text-navy-900 tracking-tighter" data-id="element-163">
                    $19.990
                  </span>
                </div>
                <span className="inline-block text-xs font-semibold text-slate-600 bg-slate-100 px-3 py-1 rounded-full" data-id="element-164">
                  Pago único · Acceso de por vida
                </span>
              </div>

              <Button size="lg" className="w-full" onClick={() => window.open('https://checkout.aula-mater.online/cart/66759304020013:1', '_blank')} data-id="element-165">
                👉 LO QUIERO
              </Button>
            </div>
          </motion.div>

          {/* Plan 2 — Pack Premium */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="relative bg-white rounded-3xl shadow-2xl border-2 border-pink-500 overflow-visible flex flex-col" data-id="element-166">
            {/* Floating ribbon badge — cleanly above the card */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10 w-max" data-id="element-167">
              <span className="inline-flex items-center gap-1.5 bg-gradient-to-r from-pink-600 to-rose-500 text-white text-[11px] font-bold px-4 py-1.5 rounded-full shadow-lg whitespace-nowrap uppercase tracking-wider" data-id="element-168">
                <Sparkles className="w-3.5 h-3.5" data-id="element-169" /> Más elegido · Mejor precio
              </span>
            </div>

            <div className="p-8 pt-10 flex flex-col flex-grow" data-id="element-170">
              <div className="flex items-center justify-center gap-2 mb-4" data-id="element-171">
                <span className="text-pink-600 font-bold text-xs uppercase tracking-widest" data-id="element-172">
                  ⭐ Pack Premium
                </span>
                <span className="text-slate-300" data-id="element-173">·</span>
                <span className="text-slate-500 font-semibold text-xs uppercase tracking-widest" data-id="element-174">
                  Todo incluido
                </span>
              </div>

              <h3 className="font-serif text-xl font-bold text-navy-900 mb-1 uppercase tracking-tight text-center" data-id="element-175">
                Pack Premium Psicopedagogía Clínica
              </h3>
              <p className="text-slate-600 text-sm mb-6 text-center" data-id="element-176">
                TODO incluido: Ebook + 5 Bonus + 2 Bonus Premium
              </p>

              <ul className="space-y-2.5 mb-6 flex-grow" data-id="element-177">
                {premiumFeatures.map((f, i) => <li key={i} className="flex items-start gap-3 text-sm" data-id="element-178">
                    <CheckCircle2 className="w-5 h-5 text-pink-600 shrink-0 mt-0.5" data-id="element-179" />
                    <span className="text-slate-700 font-medium" data-id="element-180">{f}</span>
                  </li>)}
              </ul>

              <div className="mb-6 text-center bg-pink-50/60 rounded-2xl py-5 px-4 border border-pink-100" data-id="element-181">
                <div className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-182">
                  Valor real del pack
                </div>
                <span className="text-slate-400 line-through text-base font-medium block mb-1" data-id="element-183">
                  ARS $59.970
                </span>
                <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-184">
                  <span className="text-xs font-bold text-pink-600" data-id="element-185">ARS</span>
                  <span className="text-5xl font-bold text-pink-600 tracking-tighter" data-id="element-186">
                    $29.990
                  </span>
                </div>
                <span className="inline-block text-xs font-bold text-white bg-gradient-to-r from-rose-500 to-pink-600 px-4 py-1.5 rounded-full shadow-sm mb-2" data-id="element-187">
                  🔥 ¡Ahorrás $29.980!
                </span>
                <p className="text-xs font-semibold text-pink-700" data-id="element-188">
                  Pago único · Acceso de por vida
                </p>
              </div>

              <Button size="lg" className="w-full" onClick={() => window.open('https://checkout.aula-mater.online/cart/66763514773549:1', '_blank')} data-id="element-189">
                👉 LO QUIERO TODO
              </Button>
            </div>
          </motion.div>
        </div>

        {/* Alternate purchase methods */}
        <div className="mt-10 max-w-md mx-auto" data-id="element-190">
          <p className="text-center text-xs font-bold text-slate-500 uppercase tracking-widest mb-4" data-id="element-191">
            Otras formas de comprar
          </p>
          <div className="flex flex-col gap-3" data-id="element-192">
            <button onClick={() => window.open('https://wa.me/5491124676057?text=Hola%20vi%20el%20Pack%20Psicopedagogia%C2%B4s%20Clinica%20quiero%20realizar%20la%20compra%20por%20Whatsapp%20u%20obtener%20mas%20informacion', '_blank')} className="w-full inline-flex flex-col items-center justify-center gap-0.5 bg-green-500 hover:bg-green-600 text-white font-bold py-3.5 px-6 rounded-full shadow-[0_8px_20px_rgb(34,197,94,0.3)] hover:shadow-[0_12px_25px_rgb(34,197,94,0.4)] transition-all duration-300 hover:-translate-y-0.5" data-id="element-193">
              <span className="inline-flex items-center gap-2" data-id="element-194">
                <MessageCircle className="w-5 h-5" data-id="element-195" />
                COMPRA POR WHATSAPP
              </span>
              <span className="text-[11px] font-medium text-white/90 tracking-wide" data-id="element-196">
                transferencia
              </span>
            </button>
          </div>

          <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-slate-500" data-id="element-197">
            <span data-id="element-198">✔ Acceso inmediato</span>
            <span data-id="element-199">✔ Descarga digital</span>
            <span data-id="element-200">✔ Acceso de por vida</span>
          </div>
        </div>
      </div>
    </section>;
}